import React, { ReactNode } from 'react'

import styles from '../../style.module.css'

interface Props {
    content: ReactNode
    isLoading: boolean
    isShowSumSub: boolean
}

export function Content({ content, isLoading, isShowSumSub }: Props) {
    if (isShowSumSub || isLoading) {
        return <>{content}</>
    }

    return (
        <div className={styles.modalWrap}>
            <div className={styles.modalView}>{content}</div>
        </div>
    )
}
